import React from "react";
import {RouterProvider} from "react-router-dom";

import {router} from "../router";
import OauthProviders from "../components/oauth/Providers";
import {QueryClientProvider} from "@tanstack/react-query";
import {queryClient} from "../state";
import {ErrorRoot} from "../components/ErrorBoundary";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import RootTheme from "../theme/RootTheme";
import AppDialogProvider from "./Dialogs/Provider";
import I18nProvider from "./i18n/Provider";
import {Toaster} from "../components/ui/toaster";
import BrokenEnvironmentToast from "./BrokenEnvironmentToast";
import {useSessionRefresh} from "../hooks/sessionRefresh";

export default function App() {
  useSessionRefresh();
  return (
    <React.StrictMode>
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <RootTheme>
            <ErrorRoot>
              <AppDialogProvider>
                <OauthProviders>
                  <RouterProvider router={router!} future={{v7_startTransition: true}} />
                  <Toaster />
                  <BrokenEnvironmentToast />
                </OauthProviders>
              </AppDialogProvider>
            </ErrorRoot>
          </RootTheme>
        </QueryClientProvider>
      </I18nProvider>
    </React.StrictMode>
  );
}
